import { render, staticRenderFns } from "./DrawerNombre.vue?vue&type=template&id=5a7fb4f3&"
import script from "./DrawerNombre.vue?vue&type=script&lang=js&"
export * from "./DrawerNombre.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports